var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from './Checkbox';
import includes from 'lodash/includes';

var CheckboxGroup = function (_React$Component) {
  _inherits(CheckboxGroup, _React$Component);

  function CheckboxGroup(props) {
    _classCallCheck(this, CheckboxGroup);

    var _this = _possibleConstructorReturn(this, (CheckboxGroup.__proto__ || Object.getPrototypeOf(CheckboxGroup)).call(this, props));

    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  _createClass(CheckboxGroup, [{
    key: 'handleChange',
    value: function handleChange(value, checked) {
      var _this2 = this;

      var values = this.props.options.filter(function (option) {
        if (option.value === value) {
          return checked;
        }

        return includes(_this2.props.values, option.value);
      }).map(function (option) {
        return option.value;
      });

      this.props.onChange(values);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return React.createElement(
        'div',
        { className: 'cf-checkbox__group' },
        this.props.options.map(function (option) {
          return React.createElement(Checkbox, {
            key: option.name,
            label: option.label,
            name: option.name,
            value: option.value,
            checked: includes(_this3.props.values, option.value),
            onChange: function onChange(e) {
              return _this3.handleChange(option.value, e.target.checked);
            }
          });
        })
      );
    }
  }]);

  return CheckboxGroup;
}(React.Component);

CheckboxGroup.propTypes = {
  values: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([false])]).isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })).isRequired
};

export default CheckboxGroup;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-checkbox/es/CheckboxGroup.js
// module id = 822
// module chunks = 0